import request from "root/js/request";

const getAbcPiesOzon = async ({
  wb_api_key_ids,
  date_from,
  date_to,
  subject,
  category_id__in,
  brand_id__in,
  subject_id__in = subject, // для обратной совместимости
  product_id__in,
  barcode__in,
  analyze_by,
  labels,
  xyz_labels,
  group_by,
  ...rest
}) => {
  const response = await request({
    url: "ozon_analytics/abc_analysis/pie_data/",
    method: "get",
    params: {
      wb_api_key_ids,
      date_from,
      date_to,
      category_id__in,
      brand_id__in,
      subject_id__in,
      product_id__in,
      barcode__in,
      analyze_by,
      labels,
      xyz_labels,
      group_by,
      ...rest,
    },
  });
  return response.data;
};

export { getAbcPiesOzon };
